module.exports = __webpack_public_path__ + "img/sber.c94281b3.png";